import { addJs } from '../utils/documentMethods';

const ADOBE_WEB_CONCERN_CODE = 'awsdk';
const ADOBE_WEB_CONCERN_KEY = 'adobeWebSDKTool';

export default class AdobeWebSdkProcessor {
  process(baseConfig: any) {
    const awsdkConfig = baseConfig[ADOBE_WEB_CONCERN_KEY];
    const awsdkScriptSrcMin = awsdkConfig.script.src.minified;
    const isAsync = awsdkConfig.script.loadingStrategy.toLowerCase() === 'async';
    addJs(awsdkScriptSrcMin, 'head', { async: isAsync, id: 'awsdklaunch' });
  }

  getConcernCode() {
    return ADOBE_WEB_CONCERN_CODE;
  }
}
